import { render, staticRenderFns } from "./TicketType.vue?vue&type=template&id=756f9964&"
import script from "./TicketType.vue?vue&type=script&lang=js&"
export * from "./TicketType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports